
export default (el) => {

  const $block = $(el),
        $navButtons = $block.find('.scrolling-sections-block-nav-button'),
        $sections = $block.find('.scrolling-sections-block-section');
  let pendingTarget = null;

  const setActiveButton = (target) => {
    $navButtons.each(function() {
      $(this).attr('data-active', $(this).data('target') === target ? 'true' : 'false');
    });
  };

  const firstTarget = $navButtons.first().data('target');

  if (firstTarget) {
    setActiveButton(firstTarget);
  }

  $navButtons.on('click', function() {
    const target = $(this).data('target');
    const $targetSection = $sections.filter(`[data-section="${target}"]`);

    if ($targetSection.length) {
      pendingTarget = target;
      setActiveButton(target);
      $targetSection[0].scrollIntoView({ behavior: 'smooth' });
    }
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      const visibleEntries = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

      if (visibleEntries.length) {
        if (pendingTarget) {
          const pendingEntry = visibleEntries.find((entry) => entry.target.dataset.section === pendingTarget);

          if (pendingEntry) {
            setActiveButton(pendingTarget);
            pendingTarget = null;
          }

          return;
        }

        setActiveButton(visibleEntries[0].target.dataset.section);
      }
    }, {
      root: null,
      rootMargin: '-20% 0px -55% 0px',
      threshold: [0.1, 0.25, 0.5, 0.75]
    });

    $sections.each(function() {
      observer.observe(this);
    });
  }
};
